import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "mask0_92_14",
      style: {"mask-type":"alpha"},
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "20",
      height: "20"
    }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        fill: "#D9D9D9"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#mask0_92_14)" }, [
      _createElementVNode("path", {
        d: "M4.16667 3.33329V8.35413V8.33329V16.6666V3.33329ZM4.16667 18.3333C3.70833 18.3333 3.31597 18.1701 2.98958 17.8437C2.66319 17.5173 2.5 17.125 2.5 16.6666V3.33329C2.5 2.87496 2.66319 2.4826 2.98958 2.15621C3.31597 1.82982 3.70833 1.66663 4.16667 1.66663H10.8333L15.8333 6.66663V8.74996C15.5694 8.63885 15.2986 8.55204 15.0208 8.48954C14.7431 8.42704 14.4583 8.3819 14.1667 8.35413V7.49996H10V3.33329H4.16667V16.6666H9.1875C9.40972 17 9.65972 17.309 9.9375 17.5937C10.2153 17.8784 10.5208 18.125 10.8542 18.3333H4.16667ZM13.75 15.8333C14.3333 15.8333 14.8264 15.6319 15.2292 15.2291C15.6319 14.8263 15.8333 14.3333 15.8333 13.75C15.8333 13.1666 15.6319 12.6736 15.2292 12.2708C14.8264 11.868 14.3333 11.6666 13.75 11.6666C13.1667 11.6666 12.6736 11.868 12.2708 12.2708C11.8681 12.6736 11.6667 13.1666 11.6667 13.75C11.6667 14.3333 11.8681 14.8263 12.2708 15.2291C12.6736 15.6319 13.1667 15.8333 13.75 15.8333ZM18 19.1666L15.75 16.9166C15.4583 17.1111 15.1424 17.2569 14.8021 17.3541C14.4618 17.4513 14.1111 17.5 13.75 17.5C12.7083 17.5 11.8229 17.1354 11.0938 16.4062C10.3646 15.677 10 14.7916 10 13.75C10 12.7083 10.3646 11.8229 11.0938 11.0937C11.8229 10.3645 12.7083 9.99996 13.75 9.99996C14.7917 9.99996 15.6771 10.3645 16.4062 11.0937C17.1354 11.8229 17.5 12.7083 17.5 13.75C17.5 14.1111 17.4514 14.4618 17.3542 14.802C17.2569 15.1423 17.1111 15.4583 16.9167 15.75L19.1667 18L18 19.1666Z",
        fill: "#1C1B1F"
      })
    ], -1)
  ]))]))
}
export default { render: render }